const isDataUrl = (dataUrl?: string): boolean => {
  if (!dataUrl)
    return false;

  return dataUrl.startsWith('data:image/');
};
export default isDataUrl;